import {
  UPDATE_MICRO_LOANS_SETTINGS_DATA_ERROR,
  UPDATE_MICRO_LOANS_SETTINGS_DATA_START,
  UPDATE_MICRO_LOANS_SETTINGS_DATA_SUCCESS,
} from 'constants/action-types/settings/updateMicroLoansSettingData';

export default (state, { type, payload }) => {
  switch (type) {
    case UPDATE_MICRO_LOANS_SETTINGS_DATA_START:
      return {
        ...state,
        updateMicroloanSettings: {
          loading: true,
          error: null,
        },
      };
    case UPDATE_MICRO_LOANS_SETTINGS_DATA_ERROR:
      return {
        ...state,
        updateMicroloanSettings: {
          ...state.updateMicroloanSettings,
          error: payload,
          loading: false,
        },
      };
    case UPDATE_MICRO_LOANS_SETTINGS_DATA_SUCCESS:
      return {
        ...state,
        updateMicroloanSettings: {
          ...state.updateMicroloanSettings,
          data: payload,
          loading: false,
        },
      };
    default:
      return null;
  }
};
